import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@airia/ui';
import PlaybookListItem from './PlaybookListItem';
import ChatDrawer from '../chat/ChatDrawer';
import Chat from '../chat/Chat';
const PlaybookList = ({ playbooks, onPlaybookClick, onDeletePlaybook, }) => {
    const [filteredPlaybooks, setFilteredPlaybooks] = React.useState(playbooks);
    const [search, setSearch] = React.useState('');
    const [drawerOpen, setDrawerOpen] = React.useState(false);
    useEffect(() => {
        if (search === '') {
            setFilteredPlaybooks(playbooks);
        }
        else {
            const filtered = playbooks.filter((playbook) => playbook.name.toLowerCase().includes(search.toLowerCase()));
            setFilteredPlaybooks(filtered);
        }
    }, [playbooks, search]);
    const onSearch = (e) => {
        setSearch(e.target.value);
    };
    return (_jsxs("div", { className: 'px-4 py-2 h-full flex flex-col bg-background', children: [_jsxs("div", { className: "flex-1 min-h-0 overflow-y-auto", children: [playbooks.length > 0 && (_jsxs("div", { className: 'flex items-center border-b', children: [_jsx(Search, {}), _jsx(Input, { placeholder: 'Search Playbooks', className: 'border-none bg-transparent focus-visible:ring-0 focus-visible:outline-none', value: search, onChange: onSearch })] })), _jsx("div", { className: 'flex flex-col gap-2 my-2', children: filteredPlaybooks.length > 0 ? (filteredPlaybooks.map((playbook) => (_jsx(PlaybookListItem, { playbook: playbook, onClick: onPlaybookClick, onDelete: onDeletePlaybook }, playbook.id)))) : (_jsx("div", { children: _jsx("h1", { className: 'text-xl text-center', children: "No playbooks available." }) })) })] }), _jsx("div", { className: "flex-shrink-0", children: _jsx(ChatDrawer, { open: drawerOpen, onOpenChange: setDrawerOpen, children: _jsx(Chat, {}) }) })] }));
};
export default PlaybookList;
